import {Component, Input, OnInit} from '@angular/core';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {CommonConstant} from '../../app.constants';

@Component({
  selector: 'achoo-placeholder',
  templateUrl: './achoo-placeholder.component.html',
  styleUrls: ['./achoo-placeholder.component.scss']
})
export class AchooPlaceholderComponent implements OnInit {
  @Input() normalPlaceholder = true;
  @Input() facebookPlaceholder = false;
  @Input() isFullscreenLoader = false;
  @Input() placeholderId: string;

  @Input() warningMessage: string;
  @Input() showWarningMessage = false;


  private activatedHolders: string[] = [];

  constructor(private placeholderVisibilityService: PlaceholderVisibilityService) {
    this.placeholderVisibilityService.triggerPlaceholder$.subscribe((holder) => {
      if (holder.action === CommonConstant.SHOW_PLACEHOLDER) {
        this.activatedHolders.push(holder.id);
      }

      if (holder.action === CommonConstant.HIDE_PLACEHOLDER) {
        this.activatedHolders = this.activatedHolders.filter(h => h !== holder.id);
      }
    });
  }

  ngOnInit() {
  }

  shouldShowPlaceholder() {
    return this.activatedHolders.findIndex((h) => h === this.placeholderId) >= 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-placeholder/achoo-placeholder.component.ts